/* eslint-disable import/prefer-default-export */
// you should have an .env file specifying these configs, following the Create React App required prefix with REACT_APP.
// CRA manages putting the .env variables on process.env.
export const apiEndpoint = process.env.REACT_APP_API_URI;
export const graphqlApiUri = process.env.REACT_APP_GRAPHQL_API_URI;
export const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const s3BucketUrl = process.env.REACT_APP_S3_BUCKET_URL;
export const buildVersion = process.env.REACT_APP_BUILD_VERSION;
export const buildID = process.env.REACT_APP_BUILD_ID;
